import type { ReactElement } from 'react';
import React from 'react';
import type { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import type { LinkProps } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import TooltipItem from 'atom-components/tooltip-item';

export type IconActionLinkProps = LinkProps & {
  id: string;
  tooltip: string;
  icon: IconProp;
  disabled?: boolean;
  iconClassName?: string;
  buttonClassName?: string;
  className?: string;
  isExternal?: boolean;
  to: string;
  size?: SizeProp;
};

export default function IconActionLink({
  id,
  tooltip,
  icon,
  to,
  disabled = false,
  isExternal = false,
  iconClassName = '',
  buttonClassName,
  className,
  size = 'lg',
  ...rest
}: IconActionLinkProps): ReactElement {
  return (
    <TooltipItem id={id} tooltip={tooltip}>
      {disabled && (
        <Button className={clsx(buttonClassName, className)} color="light" disabled={disabled}>
          <FontAwesomeIcon icon={icon} size={size} className={`${iconClassName}`} fixedWidth />
        </Button>
      )}
      {!disabled && !isExternal && (
        <Link className={clsx('btn btn-light', buttonClassName, className)} to={to} {...rest}>
          <FontAwesomeIcon icon={icon} size={size} className={`${iconClassName}`} fixedWidth />
        </Link>
      )}
      {!disabled && isExternal && (
        <a className={clsx('btn btn-light', buttonClassName, className)} href={to} {...rest}>
          <FontAwesomeIcon icon={icon} size={size} className={`${iconClassName}`} fixedWidth />
        </a>
      )}
    </TooltipItem>
  );
}
